import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'components/i18n';
import { SaleItem } from '../types';
import api from 'libs/api';
import { queryCache } from 'react-query';
import SaleItemForm from './SaleItemForm';
import { useFormModal } from 'components/modal-dialog';

type SaleItemModalOptions = {
  isNew?: boolean;
  saleItem: SaleItem;
  onSubmit?: (saleItem: SaleItem) => any;
}

const useSaleItemModal = () => {

  const [showModal, hideModal] = useFormModal();
  const intl = useIntl();

  const showSaleItemModal = useCallback((options: SaleItemModalOptions) => {
    const {saleItem, onSubmit} = options;
    showModal({
      id: 'saleItemsModal',
      title: saleItem.isNew? <FormattedMessage id="sale.SaleItemModal.title.create" defaultMessage="New item"/> : <FormattedMessage id="sale.SaleItemModal.title.edit" defaultMessage="Edit item"/>,
      initialValues: saleItem,
      onSubmit: async (newValues: SaleItem) => {
        const updatedItem = await api.put('/sale-items', newValues, {params: {filter: {include: 'vatCode'}}}) as SaleItem;
        queryCache.invalidateQueries('saleItems');
        if(onSubmit) onSubmit(updatedItem);
      },
      form: SaleItemForm,
      submitText: saleItem.isNew? intl.formatMessage({id:"sale.SaleItemModal.submitText.create",defaultMessage:"Create new item"}) : intl.formatMessage({id:"sale.SaleItemModal.submitText.edit",defaultMessage:"Save item"}),
      width: 'medium',
    });
  },
    [showModal]);

  return showSaleItemModal;
};

export default useSaleItemModal;
